module.exports = __webpack_public_path__ + "img/garden_gdzb_1.6028a860.png";